import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'ha/i18n';

import { logout } from 'ha/modules/AuthLogic/actions';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';

import MobileMainMenu from '../components/MobileMainMenu';

export const MobileMainMenuContainer: React.FC = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);

  const dispatch = useDispatch();
  const { urlResolver } = useIntl();
  const handleLogout = React.useCallback(() => {
    dispatch(logout(urlResolver.getHomeUrl()));
  }, []);

  return (
    <MobileMainMenu isAuthenticated={isAuthenticated} logout={handleLogout} />
  );
};

export default MobileMainMenuContainer;
